import { render, staticRenderFns } from "./SkvQuestions.vue?vue&type=template&id=85b72cf2&scoped=true"
import script from "./SkvQuestions.vue?vue&type=script&lang=js"
export * from "./SkvQuestions.vue?vue&type=script&lang=js"
import style0 from "./SkvQuestions.vue?vue&type=style&index=0&id=85b72cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b72cf2",
  null
  
)

export default component.exports